import React from 'react';
import { PictureIcon } from '../../../assets/icons'
import { Translate } from '../../../language';
import ButtonCircle from '../../../utils/components/ButtonCircle/ButtonCircle';
import Button from '../../../utils/components/Button/Button';
import style from './MessageRooms.module.css'
import ImageNameDescription from '../../../utils/components/ImageNameDescription/ImageNameDescription';
import { useTokenCallback } from '../../../utils/hooks/useTokenCallback';
import { getAllRooms, seeMyRooms, seeRoomsIBelong } from '../../../actions/userActions';
import { seeListChatCategories } from '../../../admin/actions/categoriesActions';
import { useDispatch } from 'react-redux';

const MessageRooms = () => {
    const dispatch = useDispatch()
   // const {allRooms} = useSelector(state=>state.userInfo)
  //  const {listChatCategories} = useSelector(state=>state.socialCategoriesAdmin)
    useTokenCallback(()=>{
        dispatch(getAllRooms())
        dispatch(seeListChatCategories())
        dispatch(seeRoomsIBelong())
        dispatch(seeMyRooms())
        
    },[])
    return (
        <div className={style.content}>
            {Translate('textWelcomeRooms', 'es')}
        </div>
    );
};

export default MessageRooms;
